import { Observable, Subject, Subscription, timer } from 'rxjs';
import { shareReplay, takeUntil, tap } from 'rxjs/operators';

export class CacheableGet<ReturnType> {

  /**
   * Emite um novo valor sempre que o cache é invalidado
   */
  public get shouldUpdate(): Observable<void> {
    return this._shouldUpdate.asObservable();
  }
  private _shouldUpdate = new Subject<void>();
  private shouldUpdateTimer: Subscription = null;

  /**
   * Observavel do request em andamento
   */
  private getRequest: Observable<ReturnType> = null;

  public constructor(
    private readonly cacheTime: number,
    private getApiCall: () => Observable<ReturnType>,
  ) {}

  public get(): Observable<ReturnType> {
    if (!this.getRequest) {
      this.getRequest = this.getApiCall().pipe(
        takeUntil(this.shouldUpdate),
        tap(() => {
          this.clearMark();
          this.shouldUpdateTimer = timer(this.cacheTime).subscribe(() => this.markForUpdate());
        }),
        shareReplay(1),
      );
    }

    return this.getRequest;
  }

  public clearMark() {
    if (!this.shouldUpdateTimer) {
      return;
    }

    this.shouldUpdateTimer.unsubscribe();
    this.shouldUpdateTimer = null;
  }

  /**
   * Força a atualização da solicitação no próximo
   */
  public markForUpdate() {
    this.clearMark();
    this.getRequest = null;
    this._shouldUpdate.next();
  }
}
